// store.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: 'tc',  // 默认语言为英语
    indexPage: '', // 首页默认的swiper展示页面
    tabActive: 'all' // 进入首页默认加载的数据
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
    },
    SET_INDEX_PAGE: (state, indexPage) => {
      state.indexPage = indexPage
    },
    SET_TAB_ACTIVE:(state, indexPage) => {
      state.tabActive = indexPage
    },
  }
})
